import React, { useEffect } from 'react';

import LinearProgress from '@mui/material/LinearProgress'

// MUI Icons

const style = {
    linearProgress: {
        position: 'absolute',
        top: 0,
        width: '100%',
    },
}

function CustomLinearProgress(props) {

    const { loading, ...rest } = props


    // On mount
    useEffect(() => {

        return () => {
            // Clean up
        }
    }, [])

    return (
        loading ? <LinearProgress sx={style.linearProgress} {...rest} /> : null
    )
}

// Export
export default CustomLinearProgress
